import CrudListing from "components/crud/CrudListing";

import RoleModal from "./RoleModal";
import { roleColumns } from "./columns";

import {
  getRoles,
  deleteRole,
} from "services/api/roleApi";


export default function Roles() {

  return (

    <CrudListing

      title="Roles"

      columns={roleColumns}

      Modal={RoleModal}

      fetchData={async () => {

        const response =
          await getRoles();


        /*
        |--------------------------------------------------------------------------
        | API RESPONSE
        |--------------------------------------------------------------------------
        |
        | {
        |   status: true,
        |   data: {
        |     roles: [...]
        |   }
        | }
        |
        */

        const roles =
          response?.data?.roles ||
          response?.roles ||
          [];


        return {

          data: {

            data: {

              records:
                Array.isArray(roles)
                  ? roles
                  : [],

            },

          },

        };

      }}

      deleteData={deleteRole}

      responseDataKey="records"

      localSearch

      searchPlaceholder="Search Role..."

      addButtonText="Add Role"

    />

  );

}